import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
// import router from './router'
import { useAuthStore } from '@/stores/auth'
import { isValidJWTFormat } from '@/utils/jwt'




const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/components/HomePage.vue'),
    meta: { public: true }

  },

  // 登录路由
  {
    path:'/login',
    name:'Login',
    component: () => import('@/components/Login.vue'),
    meta: { public: true }
  },
  //   {
  //   path:'/register',
  //   name:'Register',
  //   component: () => import('@/components/Register.vue'),
  //   meta: { public: false }
  // },
  // 平台介绍路由

  
  // 平台概述
  {
    path: '/platform-intro/overview',
    name: 'PlatformOverview',
    component: () => import('@/views/platform-intro/PlatformOverviewPage.vue'),
    meta: { public: true }
  },
  // 核心功能
  {
    path: '/platform-intro/core-function',
    name: 'CoreFunction',
    component: () => import('@/views/platform-intro/CoreFunctionPage.vue'),
    meta: { public: true }
  },
  // 团队介绍
  {
    path: '/platform-intro/team-intro',
    name: 'TeamIntro',
    component: () => import('@/views/platform-intro/TeamIntroPage.vue'),
    meta: { public: true }
  },
  // 最新动态
  {
    path: '/platform-intro/latest-news',
    name: 'LatestNews',
    component: () => import('@/views/platform-intro/LatestNewsPage.vue'),
    meta: { public: true }
  },
  // 学术成果
  {
    path: '/platform-intro/academic-achievements',
    name: 'AcademicAchievements',
    component: () => import('@/views/platform-intro/AcademicAchievementsPage.vue'),
    meta: { public: true }
  },
  // 监测预测路由
  // 宏观经济
  {
    path: '/economic-monitoring/macro-economy',
    name: 'MacroEconomy',
    component: () => import('@/views/economic-monitoring/MacroEconomyPage.vue'),
     meta: { requiresAuth: true },
  },
  // 区域经济
  {
    path: '/economic-monitoring/regional-economy',
    name: 'RegionalEconomy',
    component: () => import('@/views/economic-monitoring/RegionalEconomyPage.vue'),
     meta: { requiresAuth: true }
  },
  // 省市重点
  {
    path: '/economic-monitoring/key-economy',
    name: 'KeyEconomy',
    component: () => import('@/views/economic-monitoring/KeyEconomyPage.vue'),
     meta: { requiresAuth: true }
  },
  // 区域经济
  {
    path: '/economic-monitoring/economic-glance',
    name: 'EconomicGlance',
    component: () => import('@/views/economic-monitoring/EconomicGlance.vue'),
     meta: { requiresAuth: true }
  },
    // 指标指数
  {
    path: '/economic-monitoring/indicator',
    name: 'Indicator',
    component: () => import('@/views/economic-monitoring/Indicator.vue'),
     meta: { requiresAuth: true }
  },
  // 世界经济
    {
    path: '/economic-monitoring/world-economy',
    name: 'WorldEconomy',
    component: () => import('@/views/economic-monitoring/WorldEconomy.vue'),
     meta: { requiresAuth: true }
  },

  // 政策评估路由
  // // 货币政策
  // {
  //   path: '/policy-assessment/monetary-policy',
  //   name: 'MonetaryPolicy',
  //   component: () => import('@/views/policy-simulation/MonetaryPolicyPage.vue')
  // },
  // 政策仿真
  {
    path: '/policy-assessment/monetary-policy',
    name: 'MonetaryPolicy',
    component: () => import('@/views/policy-assessment/MonetaryPolicyPage.vue'),
     meta: { requiresAuth: true }
  },
  // 政策仿真
   {
    path: '/policy-assessment/policy-simulation',
    name: 'PolicySimulation',
    component: () => import('@/views/policy-assessment/PolicySimulationPage.vue'),
     meta: { requiresAuth: true }
  },
  // 产业政策
    {
    path: '/policy-assessment/industry-policy',
    name: 'IndustryPolicy',
    component: () => import('@/views/policy-assessment/IndustryPolicyPage.vue'),
     meta: { requiresAuth: true }
  },
  // 预测分析详情
  {
    path: '/policy-assessment/industry-policy/prediction-analysis-detail',
    name: 'PredictionAnalysisDetail',
    component: () => import('@/views/policy-assessment/industry-policy-subpage/PredictionAnalysisDetailPage.vue'),
     meta: { requiresAuth: true }
  },
  // 仿真模拟详情
  {
    path: '/policy-assessment/industry-policy/simulation-detail',
    name: 'SimulationDetail',
    component: () => import('@/views/policy-assessment/industry-policy-subpage/SimulationDetailPage.vue'),
     meta: { requiresAuth: true }
  },
  // 财政专题
  {
    path: '/policy-assessment/fiscal-policy',
    name: 'FiscalPolicy',
    component: () => import('@/views/policy-assessment/FiscalPolicyPage.vue'),
     meta: { requiresAuth: true }
  },

  // 经济感受路由
  // 情绪指数
  {
    path: '/situation-awareness/economic-expectation-index',
    name: 'EconomicExpectationIndex',
    component: () => import('@/views/situation-awareness/EconomicExpectationIndexPage2.vue'),
     meta: { requiresAuth: true }
  },
  // 经济预期指数
  {
    path: '/situation-awareness/monitor-warning',
    name: 'MonitorWarning',
    component: () => import('@/views/situation-awareness/MonitorWarning.vue'),
    meta: { requiresAuth: true }
  },
  // 消费者情绪指数
  {
  path: '/situation-awareness/consumer-sentiment',
  name: 'ConsumerSentiment',
  component: () => import('@/views/situation-awareness/ConsumerSentiment.vue'),
  meta: { requiresAuth: true }
  },
  // 信用相关指数
  {
  path: '/situation-awareness/credit-related',
  name: 'CreditRelated',
  component: () => import('@/views/situation-awareness/CreditRelated.vue'),
  meta: { requiresAuth: true }
  },
  // 专题研究路由
  // 可持续发展
  {
    path: '/thematic-research/sustainable-development',
    name: 'SustainableDevelopment',
    component: () => import('@/views/thematic-research/SustainableDevelopmentPage.vue'),
    meta: { requiresAuth: true }
  },
  // 关税贸易
  {
    path: '/thematic-research/tariff-trade',
    name: 'TariffTrade',
    component: () => import('@/views/thematic-research/TariffTrade.vue'),
    meta: { requiresAuth: true }
  },
  // 关税税率
  {
    path: '/thematic-research/tariff-rate',
    name: 'TariffRate',
    component: () => import('@/views/thematic-research/TariffRate.vue'),
    meta: { requiresAuth: true }
  },
  // 贸易监测
  {
    path: '/thematic-research/trade-risk',
    name: 'trade-risk',
    component: () => import('@/views/thematic-research/TradeRisk.vue'),
    meta: { requiresAuth: true }
  },
    // 关税分析
  {
    path: '/thematic-research/tariff-assessment',
    name: 'tariff-assessment',
    component: () => import('@/views/thematic-research/TariffAssessment.vue'),
    meta: { requiresAuth: true }
  },
  // 报告中心
  {
    path: '/thematic-research/report-center',
    name: 'ReportCenter',
    component: () => import('@/views/thematic-research/ReportCenter.vue'),
    meta: { requiresAuth: true }
  },
  // 报告中心邀请链接
  {
    path: '/report/invate-link',
    name: 'InvateLink',
    component: () => import('@/views/onlyoffice/invate.vue'),
    meta: { requiresAuth: true }
  },
    // 国际贸易
  // {
  //   path: '/thematic-research/international-trade',
  //   name: 'InternationalTrade',
  //   component: () => import('@/views/thematic-research/InternationalTrade.vue'),
  //   meta: { requiresAuth: true }
  // },
      // 国际贸易
  {
    path: '/thematic-research/international-trade',
    name: 'InternationalTrade',
    component: () => import('@/views/thematic-research/IntroPage.vue'),
    meta: { requiresAuth: true }
  },
  // 贸易构成
    {
    path: '/thematic-research/trade-ccenter',
    name: 'TradeCenter',
    component: () => import('@/views/thematic-research/TradeCenter.vue'),
    meta: { requiresAuth: true }
  },
  // 贸易地图 iframe 嵌入（智能体用）
  {
    path: '/embed/trade-map',
    name: 'TradeMapEmbed',
    component: () => import('@/views/thematic-research/trade-sub/TradeMapView.vue'),
    props: (route: any) => ({ initialSource: route.query.source || 'China' }),
    meta: { requiresAuth: true }
  },

  // 数据仓库路由
  // 数据概览
  {
    path: '/data-warehouse/data-overview',
    name: 'DataOverview',
    component: () => import('@/views/data-warehouse/DataOverviewPage.vue'),
    meta: { requiresAuth: true }
  },

  // 数据来源
  {
    path: '/data-warehouse/data-source',
    name: 'DataSource',
    component: () => import('@/views/data-warehouse/DataSourcePage.vue'),
    meta: { requiresAuth: true }
  },
  // 文本数据信息
  {
    path: '/data-warehouse/data-crawler',
    name: 'DataCrawler',
    component: () => import('@/views/data-warehouse//DataCrawlerPage.vue'),
    meta: { requiresAuth: true }
  },
  // 结构数据看板
    {
    path: '/data-warehouse/data-dashboard',
    name: 'StructuredDataDashboard',
    component: () => import('@/views/data-warehouse/StructuredDataDashboard.vue'),
    meta: { requiresAuth: true }
  },
  // 非结构数据看板
  {
    path: '/data-warehouse/unstructed-data-dashboard',
    name: 'UnStructuredDataDashboard',
    component: () => import('@/views/data-warehouse/UnstructedDataDashboard.vue'),
    meta: { requiresAuth: true }
  },
    //高频数据
  {
    path: '/data-warehouse/high-frequency-data',
    name: 'HighFrequencyData',
    component: () => import('@/views/data-warehouse/HighFrequencyData.vue'),
    meta: { requiresAuth: true }
  },
  // 数据集
  {
    path: '/data-warehouse/data-dataset',
    name: 'DataSet',
    component: () => import('@/views/data-warehouse/DataSetPage.vue'),
    meta: { requiresAuth: true }
  },
  // 数据分类
    {
    path: '/data-warehouse/data-classification',
    name: 'DataClassification',
    component: () => import('@/views/data-warehouse/DataClassification.vue'),
    meta: { requiresAuth: true }
  },
  {
  path: "/datasets/:id",
  name: "DatasetDetail",
  component: () => import("@/views/data-warehouse/DatasetDetail.vue"),
  meta: { requiresAuth: true }
},
// 地理系统
{
  path: "/data-warehouse/GisScreen",
  name: "GisScreen",
  component: () => import("@/views/GisScreen/GisScreen.vue"),
  meta: { fullscreen: true }
},
//灯光指数
{
  path: "/data-warehouse/light-index",
  name: "LightIndex",
  component: () => import("@/views/GisScreen/LightIndex.vue"),
  meta: { fullscreen: true }
},
//经济智图
{
  path: "/data-warehouse/economic-map",
  name: "EconomicMap",
  component: () => import("@/views/economic-gis/EconomicGis.vue"),
  meta: { fullscreen: true }
},
// 知识图谱
   {
    path: '/data-warehouse/knowledge-graph',
    name: 'KnowledgeGraph',
    component: () => import('@/views/data-warehouse/KnowledgeGraphPage.vue'),
    meta: { requiresAuth: true }
  },


  {
    path: '/data-warehouse/test-echart',
    name: 'TestEchart',
    component: () => import('@/components/EchartTheme.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/platform-intro/news-content',
    name: 'NewsContentPage',
    component: () => import('@/views/platform-intro/NewsContentPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/agent',
    name: 'LLMRAG',
    component: () => import('@/views/llm/LLMRAG.vue'),
     meta: { requiresAuth: true }
  },
  // OnlyOffice 编辑器
  {
    path: '/onlyoffice/editor',
    name: 'OnlyOfficeEditor',
    component: () => import('@/views/onlyoffice/editor.vue'),
    meta: { requiresAuth: true }
  }

];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

export default router;



router.beforeEach(async (to) => {
  const auth = useAuthStore()
  auth.initFromStorage()

  // public 页不校验
  const isPublic = to.matched.some(r => r.meta.public)
  if (isPublic) return true

  // 只对 requiresAuth 的页面进行校验
  const needAuth = to.matched.some(r => r.meta.requiresAuth)
  if (!needAuth) return true

  // 1) token 以 store 为准（initFromStorage 已做过清理/校验）
  const token = auth.token || localStorage.getItem('accessToken')

  // 2) token 不存在 / 格式不对：直接去登录
  if (!isValidJWTFormat(token)) {
    auth.logout()
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  // （可选）3) expiresAt 过期了：直接去登录（减少无意义请求）
  const expiresAt = Number(localStorage.getItem('expiresAt') || 0)
  if (expiresAt && Date.now() >= expiresAt) {
    auth.logout()
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  // 4) 去后端校验 token 是否仍有效
  // 某些敏感页可强制每次校验（例如 rshiny / onlyoffice）
  const force =
    to.path.startsWith('/rshiny') ||
    to.path.startsWith('/onlyoffice')

  const ok = await auth.validateCurrUser(force)
  if (!ok) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  return true
})